import { Factory } from 'miragejs'

export const bucket = Factory.extend({
  title(i) {
    const values = [
      'Blockchain related Keyword bucket',
      'Fintech keywords',
      'Startups Keywords',
      'eCommerce business Keywords',
      'Social Media Strategy Keywords',
      'Discord Discussion Keywords',
    ]
    return values[i % values.length]
  },
  description:
    'This is a description for the bucket for the bucketfor the bucketfor the bucket',
  total_keywords(i) {
    const values = [42, 74, 123, 456, 789]
    return values[i % values.length]
  },
  updated_at(i) {
    const values = [
      new Date('2022-07-01').toISOString(),
      new Date('2022-05-04').toISOString(),
      new Date('2022-08-07').toISOString(),
    ]
    return values[i % values.length]
  },
})
